import React from "react";
import classes from "./techOverview.module.scss";
import arrowIcon from "../../assets/arrow.svg";
import { Collapse } from "react-bootstrap";

const Depend = ({ openTab, setOpenTab }) => {
  return (
    <>
      <button
        onClick={() => {
          if (openTab !== "Depend") {
            setOpenTab("Depend");
          } else setOpenTab(null);
        }}
        aria-controls="auth-collapse-text"
        aria-expanded={openTab === "Depend"}
        className={`${classes.btn} d-flex align-items-center justify-content-between pt-3 pb-2 px-0`}
      >
        Json rpc library usage{" "}
        <img src={arrowIcon} alt="" style={{ width: "12px" }} />
      </button>
      <Collapse in={openTab === "Depend"}>
        <div id="depend-collapse-text" className={classes.content}>
          <p>
            Even though API requests can be sent to our servers via your
            preferred JavaScript method, it is recommeended to use our Json Rpc
            library, which is dependant on Axios.
          </p>
          <p>
            Note that the library has been tested and works properly using
            <span className={classes["connection-key"]}> Axios 1.4.0</span> as
            the latest versions of the dependency. If there are any conflicts
            regarding the usage of our library, please check the dependency
            version you are using.
          </p>
          <p>
            You can either install the dependency locally in your project, or
            load the adequate version from our server using CDN.
          </p>
          <p>
            Additionally, you need to reference the json rpc library you are
            using - either save it locally and import it in the project, or load
            it using CDN.
          </p>
          <table className="mb-4">
            {/* <thead>
              <th></th>
              <th>jQuery</th>
              <th>Axios</th>
            </thead> */}
            <tbody>
              <tr>
                <td className="ps-2">Dependency</td>
                {/* <td className="text-center">
                  <a
                    href={`https://${window.location.hostname}/content/3rdparty/jquery-3.6.1.min.js`}
                    className={classes.link}
                  >
                    {`https://${window.location.hostname}/content/3rdparty/jquery-3.6.1.min.js`}
                  </a>
                </td> */}
                <td className="text-center">
                  <a
                    href={`https://${window.location.hostname}/content/3rdparty/axios-1.4.0.min.js`}
                    className={classes.link}
                  >
                    {`https://${window.location.hostname}/content/3rdparty/axios-1.4.0.min.js`}
                  </a>
                </td>
              </tr>
              <tr>
                <td className="ps-2">Json Rpc</td>
                {/* <td className="text-center">
                  <a
                    href={`https://${window.location.hostname}/content/jsonrpc-2.0.js`}
                    className={classes.link}
                  >{`https://${window.location.hostname}/content/jsonrpc-2.0.js`}</a>
                </td> */}
                <td className="text-center">
                  <a
                    href={`https://${window.location.hostname}/content/jsonrpc-2.0.js`}
                    className={classes.link}
                  >{`https://${window.location.hostname}/content/jsonrpc-2.0.js`}</a>
                </td>
              </tr>
            </tbody>
          </table>
          <p>
            All API calls should have the following endpoint:{" "}
            <a
              href={`https://${window.location.hostname}/json.rpc`}
              className={classes.link}
            >{`https://${window.location.hostname}/json.rpc`}</a>
          </p>
          <p>You can define the endpoint in the following way:</p>
          <pre>
            RpcClient.config.url ={" "}
            {`https://${window.location.hostname}/json.rpc`}
          </pre>
          <p>
            As previously mentioned, authenticating with every call is
            mandatory. Your authentication credential is the connection key
            (which can be found in the dashboard). Please note that you may have
            two connection keys - a TEST and a PRODUCTION one, as explained
            under the "Authentication" section above.
          </p>
          <p>
            You can add the connection key to the call by configuring the header
            of the request in the following way:
          </p>
          <pre>
            RpcClient.config.headers['Authorization'] = 'IoT
            &lt;connectionKey&gt;:&lt;projectName&gt;'
          </pre>
          <p>
            In the end, your call should be configured in the following way:
          </p>
          <pre>
            <code>
              RpcClient.call(&quot;Extension.Execute&quot;, &#123;
              <br />
              &nbsp;&nbsp;extension: &quot;Api&quot;
              <br />
              &nbsp;&nbsp;args: &#123;
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&#47;&#47; place the request object here
              <br />
              &nbsp;&nbsp;&#125;
              <br />
              &#125;)
              <br />
              &nbsp;&nbsp;.done(result &#61;&#62; &#123; &#47;&#47; define
              function here &#125;)
              <br />
              &nbsp;&nbsp;.post()
            </code>
          </pre>
        </div>
      </Collapse>
    </>
  );
};

export default Depend;
